import { ILogger } from "@gemma/logging";
import { Modes } from "@gemma/configuration";

export function hotjar(mode: Modes, logger: ILogger) {
  let settings: {
    hjid?: number;
    hjsv: number;
  } = { hjsv: 6 };
  switch (mode) {
    case "live":
      settings.hjid = 1143958;
      break;

    case "demo":
      settings.hjid = 2191124;
      break;

    default: {
      logger.warn(`No hotjar id registered for ${mode} mode`);
      return;
    }
  }

  //@ts-ignore
  window.hj =
    //@ts-ignore
    window.hj ||
    function() {
      //@ts-ignore
      (window.hj.q = window.hj.q || []).push(arguments);
    };
  //@ts-ignore
  window._hjSettings = settings;
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.async = true;
  //@ts-ignore
  script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
  head.appendChild(script);
}
